import React, {useEffect, useState} from "react";
import {
  message,
  PageHeader,
  Space,
  Table,
  Dropdown,
  Menu,
  Button,
  DatePicker, Modal,
} from "antd";
import moment from "moment";
import {apiClient} from "../../../../services/ApiClient";
import UpdateButton from "../../../buttons/UpdateButton";
import numeral from "numeral";
import {
  CheckCircleTwoTone,
  DownOutlined, FileExcelOutlined, MoneyCollectOutlined, QuestionOutlined
} from "@ant-design/icons";
import {VehicleType} from "../../../common/AppEnums";
import {windowService} from "../../../../services/WindowService";

const { RangePicker } = DatePicker;

const CMD_EXPORT = "export";
const CMD_ACCEPT = "accept";

export default function PeriodOrdersPage() {
  let [records, setRecords] = useState([]);
  let [loading, setLoading] = useState(false);
  let [recordsStamp, setRecordsStamp] = useState(0);
  let [periodStart, setPeriodStart] = useState(moment());
  let [periodEnd, setPeriodEnd] = useState(moment());
  let [periodSum, setPeriodSum] = useState(0);
  let [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    position: 'topRight',
    defaultPageSize: 50,
    pageSizeOptions: [50, 100, 200, 300]
  });
  let [sorter, setSorter] = useState({});
  let [selectedRows, setSelectedRows] = useState([]);
  let [filters, setFilters] = useState({
    "fromDate": moment().format("YYYY-MM-DD"),
    "toDate": moment().format("YYYY-MM-DD")
  });

  useEffect(() => {
    setLoading(true);
    apiClient.getDriverPeriodOrdersReport({...filters})
      .then(res => {
        setRecords(res.records)
        if (res.records && res.records.length > 0) {
          setPeriodStart(moment(res.records[0].period_start_dt, "YYYY-MM-DD"));
          setPeriodEnd(moment(res.records[0].period_end_dt, "YYYY-MM-DD"));
          let sum = 0;
          res.records.forEach((record) => {
            sum += parseFloat(record.total_penalty_amount);
          })
          setPeriodSum(sum)
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [recordsStamp, filters]);

  const columns = [
    {
      title: "",
      align: "center",
      width: 30,
    },
    Table.SELECTION_COLUMN,
    {
      title: "Водитель",
      width: 250,
      render: (text, record, index) => {
        return (
          <Button
            type={"link"}
            style={{padding: 0}}
            onClick={() => {
              windowService.openRouteWindow(`cp/drivers/${record.driver?.id}`);
            }}
          >
            {record.driver?.full_name}
          </Button>
        );
      },
    },
    {
      title: "Телефон",
      width: 150,
      render: (text, record, index) => {
        return record.driver?.phone;
      },
    },
    {
      title: "Число заказов",
      dataIndex: "total_count",
      align: "center",
      width: 120,
      render: (text, record, index) => {
        return numeral(record.total_count).format('0')
      },
      sorter: true,
    },
    {
      title: "Сумма к списанию",
      width: 180,
      render: (text, record, index) => {
        return numeral(record.total_penalty_amount).format('0.00')
      },
      sorter: true,
    },
    {
      title: "Тип ТС",
      width: 250,
      render: (text, record, index) => {
        return VehicleType.find(el => el.id === record.car?.vehicle_type)?.title
      },
    },
    {
      title: "Списание",
      width: 120,
      render: (text, record, index) => {
        if(!record.payment_tx) {
          return "";
        }
        return <CheckCircleTwoTone twoToneColor="#52c41a" />
      },
    },
    {
      title: "",
      align: "center",
      width: 30,
    },
  ];

  const executeSelectedRecordsOperation = key => {
    if(key === CMD_EXPORT) {
      setLoading(true);
      apiClient.exportDriverPeriodOrdersReport(selectedRows.map(el => el.id))
        .then(res => {
          window.open(res.link);
          setSelectedRows([]);
        })
        .catch(err => message.error(err))
        .finally(() => setLoading(false));
    } else if(key === CMD_ACCEPT) {
      Modal.confirm({
        title: "Подтверждение",
        content: `Выполнить списания по выбранным записям (${selectedRows.length})?`,
        icon: <QuestionOutlined/>,
        visible: true,
        onOk() {
          setLoading(true);
          apiClient.acceptDriverPeriodOrdersReport(selectedRows.map(el => el.id))
            .then(res => {
              setSelectedRows([]);
              setRecordsStamp(prevState => prevState + 1);
            })
            .catch(err => message.error(err))
            .finally(() => setLoading(false));
        }
      });
    }
  };

  return (
    <>
      <PageHeader
        className="site-page-header"
        title="Заказы за период"
        extra={
          (
            <div style={{textAlign: "right"}}>
              <Space direction={"vertical"} size={"small"}>
                <span>С {periodStart.format('DD.MM.YYYY')} по {periodEnd.format('DD.MM.YYYY')}</span>
                <span>
                  {`Всего записей: ${records.length} (${selectedRows.length})`}
                  &nbsp;|&nbsp;
                  {`Сумма: ${numeral(periodSum).format('0.00')} (${numeral(selectedRows.reduce((sum, item) => sum + parseFloat(item.total_penalty_amount), 0)).format('0.00')})`}
                </span>
              </Space>
            </div>
          )
        }
      />

      <div style={{width: '100%'}}>
        <div style={{width: '20%', float: 'right'}}>
          <Space style={{float: "right", marginBottom: 10}}>
            <UpdateButton disabled={loading} onClick={ () => setRecordsStamp(prevState => prevState + 1) }/>
            {
              selectedRows.length > 0
                ? (
                  <>
                    <Dropdown
                      overlay={(
                        <Menu onClick={(e) => {
                          executeSelectedRecordsOperation(e.key);
                        }}>
                          <Menu.Item key={CMD_EXPORT} icon={<FileExcelOutlined/>}>
                            Выгрузка в Excel
                          </Menu.Item>
                          <Menu.Item key={CMD_ACCEPT} icon={<MoneyCollectOutlined/>}>
                            Выполнить списания
                          </Menu.Item>
                        </Menu>
                      )}>
                      <Button style={{textAlign: "left"}}>
                        С выбранными <DownOutlined/>
                      </Button>
                    </Dropdown>
                  </>
                ) : null
            }
          </Space>
        </div>
        <div style={{width: '80%', float: 'left'}}>
          <RangePicker
            showTime={false}
            format="DD.MM.YYYY"
            style={{width: 350}}
            onChange={(dates) => setFilters({...filters, fromDate: dates ? dates[0].format("YYYY-MM-DD") : null, toDate: dates ? dates[1].format("YYYY-MM-DD") : null})}
          />
        </div>
      </div>

      <Table
        dataSource={records}
        columns={columns}
        size="small"
        sticky
        style={{margin: '10px 0', marginTop: 40}}
        rowKey="id"
        loading={loading}
        pagination={pagination}
        scroll={{x: 1500}}
        onChange={(pagination, filters, sorter) => {
          setPagination(pagination);
          setSorter(sorter);
          setRecordsStamp(prevState => prevState + 1)
        }}
        rowSelection={{
          onChange: (selectedRowKeys, selectedRows) => {
            console.log(selectedRows);
            setSelectedRows(selectedRows);
          },
          selectedRowKeys: selectedRows.map(el => el.id)
        }}
      />

    </>
  );
}